export default "__VITE_ASSET__C$8c8Qdk__"